import { render, staticRenderFns } from "./CenarioCorpoOperacao.vue?vue&type=template&id=2642ad52&scoped=true&"
import script from "./CenarioCorpoOperacao.vue?vue&type=script&lang=js&"
export * from "./CenarioCorpoOperacao.vue?vue&type=script&lang=js&"
import style0 from "./CenarioCorpoOperacao.vue?vue&type=style&index=0&id=2642ad52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2642ad52",
  null
  
)

export default component.exports